import React from 'react';
import { Grid, FormControlLabel, Checkbox, Typography, Link } from '@mui/material';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const LawyerTermsCheckbox: React.FC<Props> = ({ checked, onChange }) => (
  <Grid item xs={12}>
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
      }
      label={
        <Typography>
          I agree to the ATJustice Attorney Directory{' '}
          <Link
            href="https://atjustice.org/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            Terms & Conditions
          </Link>
          .<Typography component="span" sx={{ color: '#000000' }}>*</Typography>
        </Typography>
      }
      sx={{ mt: 2 }}
    />
  </Grid>
);

export default LawyerTermsCheckbox;
